import React from "react";
import { View, Text } from "react-native";
import countries from "i18n-iso-countries";
import { FLAGS } from "./flagAssets";

const SPECIAL_CASES: Record<string, string> = {
  XRK: "XK", // Kosovo (unofficial)
};

/**
 * Converts ISO-3 (e.g. USA, IND) to ISO-2 (e.g. US, IN).
 */
export function getIso2FromIso3(iso3: string): string | undefined {
  if (!iso3 || typeof iso3 !== "string") return undefined;
  const upper = iso3.trim().toUpperCase();
  // Some APIs send ISO-3166-1 alpha-2 in the same field as alpha-3.
  if (upper.length === 2) return upper;
  return SPECIAL_CASES[upper] ?? countries.alpha3ToAlpha2(upper) ?? undefined;
}

type FlagProps = {
  /** ISO-3 country code (e.g. USA, IND, GBR) */
  iso3: string;
  width?: number;
  height?: number;
  /** When true, render nothing if no flag SVG (default: false = show globe) */
  hideIfMissing?: boolean;
};

/**
 * Renders a country flag from assets/images/flags when available.
 * Uses ISO-3 → ISO-2 conversion; if no SVG exists for the code, shows 🌍.
 */
export function Flag({ iso3, width = 24, height = 24, hideIfMissing = false }: FlagProps) {
  const iso2 = getIso2FromIso3(iso3);
  if (!iso2) {
    if (hideIfMissing) return <View style={{ width, height }} />;
    return <Text style={{ fontSize: Math.min(width, height) * 0.9 }}>🌍</Text>;
  }
  const FlagSvg = FLAGS[iso2.toUpperCase()];
  if (!FlagSvg) {
    if (hideIfMissing) return <View style={{ width, height }} />;
    return <Text style={{ fontSize: Math.min(width, height) * 0.9 }}>🌍</Text>;
  }
  return <FlagSvg width={width} height={height} />;
}

export default Flag;
